import { useFormStore } from "@/widgets/classic-form/form";
import { FormLevelFeatureType, useMetadataQuery } from "@/entities/form-metadata";

export const useTimespanMustMatch = () => {
    const { data: formMetadata } = useMetadataQuery();
    const timespanFeature = formMetadata.features.find((f) => f.featureType === FormLevelFeatureType.Timespan);

    const isMustMatch = useFormStore((data) => {
        if (!data.values.timespan.isVisible) {
            return true;
        }
        return data.values.timespan.matchMode === "mustMatch";
    });
    if (!timespanFeature) return true;

    return isMustMatch;
};
